import React from 'react';
import Card from '../common/Card';
import { formatCurrency, formatPercent } from '../../utils/formatters';
import { FiTrendingUp, FiTrendingDown } from 'react-icons/fi';

const AccountCard = ({ account }) => {
  const accountItems = [
    { label: '총 평가금액', value: formatCurrency(account.totalAssets), color: 'text-white' },
    { label: '예수금', value: formatCurrency(account.deposit), color: 'text-gray-400' },
    {
      label: '총 손익',
      value: `${formatCurrency(account.totalProfitLoss)} (${formatPercent(account.totalProfitRate)})`,
      color: account.totalProfitLoss >= 0 ? 'text-green-500' : 'text-red-500',
      icon: account.totalProfitLoss >= 0 ? FiTrendingUp : FiTrendingDown,
    },
    {
      label: '일일 손익',
      value: `${formatCurrency(account.dailyProfitLoss)} (${formatPercent(account.dailyProfitRate)})`,
      color: account.dailyProfitLoss >= 0 ? 'text-green-500' : 'text-red-500',
      icon: account.dailyProfitLoss >= 0 ? FiTrendingUp : FiTrendingDown,
    },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6">
      {accountItems.map((item, index) => (
        <Card key={index}>
          <div className="flex flex-col">
            <div className="text-xs sm:text-sm text-gray-400 mb-2">{item.label}</div>
            <div className={`text-lg sm:text-2xl font-bold ${item.color} flex items-center space-x-1 sm:space-x-2`}>
              {item.icon && <item.icon className="hidden sm:inline" />}
              <span className="text-sm sm:text-2xl">{item.value}</span>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default AccountCard;
